import { Box, IconButton, Tooltip, Typography, useTheme } from "@mui/material";
import React from "react";
import { BCPGlobe } from "../../../../components/icons/bcp/BCPIcons";

export default function WebSocketIndicator(props) {
  const {
    label,
    onClick,
    sx,
    status,
    // status should always be either "Live", "Connecting", "Disconnected", or "Disabled"
  } = props;

  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "end",
        alignItems: "center",
      }}
    >
      {label && <Typography>Status: {status || "Connecting"}</Typography>}

      <Tooltip
        title={
          status === "Disabled"
            ? "Live updates are currently disabled."
            : status === "Live"
              ? "You are currently connected and receiving live updates."
              : status === "Connecting" || !status
                ? "Attempting to establish connection for live updates."
                : "You are currently not receiving live updates. To reconnect, click on globe icon."
        }
      >
        <IconButton
          aria-label="connection"
          onClick={async () => {
            if (status === "Disabled") return;
            await onClick();
          }}
        >
          <BCPGlobe
            sx={{
              color:
                status === "Disabled"
                  ? theme?.palette?.text?.disabled
                  : status === "Live"
                    ? theme?.palette?.success.main
                    : status === "Connecting" || !status
                      ? theme?.palette?.warning.main
                      : theme?.palette?.error.main,
              ml: 1,
              mr: 1,
              ...sx,
            }}
          />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
